export const APP_CONFIG_DROPDOWNS = 'APP_CONFIG_DROPDOWNS';
export const RULES_CONFIG_DROPDOWNS = 'RULES_CONFIG_DROPDOWNS';
export const HISTORY_QUARTER_DROPDOWNS = 'HISTORY_QUARTER_DROPDOWNS';
export const USER_ROLES_DROPDOWNS = 'USER_ROLES_DROPDOWNS';
export const WORK_UNITS_DROPDOWNS = 'WORK_UNITS_DROPDOWNS';
